import { ITrack } from '../Interface/track'

export class SellerOfTheDay {
  beatmakerId: number
  beatmakerName: string
  followersCount: number
  beatsCount: number
  images: {
    original: string
    thumbnail: string
  }
  beats: Array<ITrack>
}
